import { Injectable } from '@angular/core';
import { ConstantsStore } from '../constants.store';
import { HttpClient } from '@angular/common/http';
import {VetrinaMese} from '../../../models/VetrinaMese';
import {TableVetrinaMese} from '../../../models/tableVetrinaMese';

@Injectable({
  providedIn: 'root'
})
export class VetrinaMeseService {

  constructor(
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  getTop(): Promise<VetrinaMese[]> {
    return this.http.get<VetrinaMese[]>(this.urlsStore.topVetrinaMeseUrl).toPromise();
  }

  get(): Promise<TableVetrinaMese> {
    return this.http.get<TableVetrinaMese>(this.urlsStore.vetrinaMeseUrl).toPromise();
  }

}
